import axios from 'axios';

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('finka_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    // Log del error para debugging
    console.error('API Error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
      isNetworkError: !err.response,
    });
    
    if (err.response?.status === 401) {
      localStorage.removeItem('finka_token');
      localStorage.removeItem('finka_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default API;
